import { useState, useContext, useEffect } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import axios from "axios";
import Alert from "../Alert";
import { alertContext } from "../contexts/AlertProvider";
import { authContext } from "../contexts/AuthProvider";

const ForgotPassword = () => {
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const { isAuth } = useContext(authContext);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [encryptedOtp, setEncryptedOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formStage, setFormStage] = useState(1);
  const navigate = useNavigate();
  const sendVerificationCode = (event) => {
    event.preventDefault();
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "send-verification-code",
        {
          email: email,
        },
        {
          withCredentials: false,
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.code === 0) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "danger",
          });
        }
        if (res.data.code === 1) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "success",
          });
          setFormStage(2);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const verifyCode = (event) => {
    event.preventDefault();
    axios
      .post(process.env.REACT_APP_API_ENDPOINT + "verify-code", {
        email: email,
        otp: otp,
      })
      .then((res) => {
        if (res.data.code === 0) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "danger",
          });
        }
        if (res.data.code === 1) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "success",
          });
          setEncryptedOtp(res.data.data);
          setFormStage(3);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const login = (event) => {
    event.preventDefault();
    axios
      .post(process.env.REACT_APP_API_ENDPOINT + "reset-password", {
        email: email,
        otp: encryptedOtp,
        password: password,
        confirmPassword: confirmPassword,
      })
      .then((res) => {
        if (res.data.code === 0) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "danger",
          });
        }
        if (res.data.code === 1) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "success",
          });
          navigate("/login");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (isAuth === true) {
      navigate("/dashboard");
    }
  }, [isAuth]);
  return (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Authentication - Sign-in */}
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        {/*begin::Body*/}
        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
          {/*begin::Form*/}
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            {/*begin::Wrapper*/}
            <div className="w-lg-500px p-10">
              {/*begin::Form*/}
              {formStage === 1 ? (
                <form
                  className="form w-100"
                  noValidate="novalidate"
                  id="kt_sign_in_form"
                  onSubmit={sendVerificationCode}
                >
                  {/*begin::Heading*/}
                  <div className="text-center mb-11">
                    {/*begin::Logo*/}
                    <Link to="/" className="mb-0 mb-lg-12">
                      <img
                        alt="Logo"
                        src="../../../assets/media/logos/logo.png"
                        style={{ width: "250px" }}
                      />
                    </Link>
                    {/*end::Logo*/}
                    {/*begin::Title*/}
                    <h1 className="text-gray-900 fw-bolder mb-3">
                      Forgot Password
                    </h1>
                    {/*end::Title*/}

                    {/*begin::Subtitle*/}
                    <div className="text-gray-500 fw-semibold fs-6">
                      {process.env.REACT_APP_BRAND_NAME || ""} Admin Panel
                    </div>
                    {/*end::Subtitle-*/}
                  </div>
                  {/*begin::Heading*/}

                  {/*begin::Input group-*/}
                  <div className="fv-row mb-8">
                    {/*begin::Email*/}
                    <input
                      type="text"
                      placeholder="Email/Username"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      autoComplete="off"
                      className="form-control bg-transparent"
                    />
                    {/*end::Email*/}
                  </div>

                  {/*begin::Submit button*/}
                  <div className="d-grid mb-10">
                    <button type="submit" className="btn bg-primary link-light">
                      Send Verification Code
                    </button>
                  </div>
                  {/*end::Submit button*/}
                  {/*begin::Wrapper*/}
                  <div className="text-center fs-base fw-semibold mb-8">
                    {/*begin::Link*/}
                    <Link to="/login" className="link-primary">
                      Remember Password ?
                    </Link>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                </form>
              ) : (
                ""
              )}
              {formStage === 2 ? (
                <form
                  className="form w-100"
                  noValidate="novalidate"
                  id="kt_sign_in_form"
                  onSubmit={verifyCode}
                >
                  {/*begin::Heading*/}
                  <div className="text-center mb-11">
                    {/*begin::Logo*/}
                    <a href="../../../index.html" className="mb-0 mb-lg-12">
                      <img
                        alt="Logo"
                        src="../../../assets/media/logos/logo.png"
                        style={{ width: "250px" }}
                      />
                    </a>
                    {/*end::Logo*/}
                    {/*begin::Title*/}
                    <h1 className="text-gray-900 fw-bolder mb-3">
                      Forgot Password
                    </h1>
                    {/*end::Title*/}

                    {/*begin::Subtitle*/}
                    <div className="text-gray-500 fw-semibold fs-6">
                      {process.env.REACT_APP_BRAND_NAME || ""} Admin Panel
                    </div>
                    {/*end::Subtitle-*/}
                  </div>
                  {/*begin::Heading*/}

                  {/*begin::Input group-*/}
                  <div className="fv-row mb-8">
                    {/*begin::Email*/}
                    <input
                      type="text"
                      placeholder="Enter 6 Digit Verification Code"
                      value={otp}
                      onChange={(e) => {
                        setOtp(e.target.value);
                      }}
                      autoComplete="off"
                      className="form-control bg-transparent"
                    />
                    {/*end::Email*/}
                  </div>

                  {/*begin::Submit button*/}
                  <div className="d-grid mb-10">
                    <button type="submit" className="btn bg-primary link-light">
                      Verify Code
                    </button>
                  </div>
                  {/*end::Submit button*/}
                  {/*begin::Wrapper*/}
                  <div className="text-center fs-base fw-semibold mb-8">
                    {/*begin::Link*/}
                    <Link to="/login" className="link-primary">
                      Remember Password ?
                    </Link>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                </form>
              ) : (
                ""
              )}
              {formStage === 3 ? (
                <form
                  className="form w-100"
                  noValidate="novalidate"
                  id="kt_sign_in_form"
                  onSubmit={login}
                >
                  {/*begin::Heading*/}
                  <div className="text-center mb-11">
                    {/*begin::Logo*/}
                    <a href="../../../index.html" className="mb-0 mb-lg-12">
                      <img
                        alt="Logo"
                        src="../../../assets/media/logos/logo.png"
                        style={{ width: "250px" }}
                      />
                    </a>
                    {/*end::Logo*/}
                    {/*begin::Title*/}
                    <h1 className="text-gray-900 fw-bolder mb-3">
                      Forgot Password
                    </h1>
                    {/*end::Title*/}

                    {/*begin::Subtitle*/}
                    <div className="text-gray-500 fw-semibold fs-6">
                      {process.env.REACT_APP_BRAND_NAME || ""} Admin Panel
                    </div>
                    {/*end::Subtitle-*/}
                  </div>
                  {/*begin::Heading*/}

                  {/*begin::Input group-*/}
                  <div className="fv-row mb-8">
                    {/*begin::Email*/}
                    <input
                      type="password"
                      placeholder="Enter New Password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      autoComplete="off"
                      className="form-control bg-transparent"
                    />
                    {/*end::Email*/}
                  </div>
                  <div className="fv-row mb-8">
                    {/*begin::Email*/}
                    <input
                      type="password"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                      }}
                      autoComplete="off"
                      className="form-control bg-transparent"
                    />
                    {/*end::Email*/}
                  </div>
                  {/*begin::Submit button*/}
                  <div className="d-grid mb-10">
                    <button type="submit" className="btn bg-primary link-light">
                      Reset Password
                    </button>
                  </div>
                  {/*end::Submit button*/}
                  {/*begin::Wrapper*/}
                  <div className="text-center fs-base fw-semibold mb-8">
                    {/*begin::Link*/}
                    <Link to="/login" className="link-primary">
                      Remember Password ?
                    </Link>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                </form>
              ) : (
                ""
              )}
              {/*end::Form*/}
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Form*/}
        </div>
        {/*end::Body*/}
      </div>
      {/*end::Authentication - Sign-in*/}
    </div>
  );
};

export default ForgotPassword;
